<template>
  <div
    class="field field--textarea"
    :style="{ '--form-item-width': grid.Cols, '--form-item-height': grid.Rows, '--form-item-start': grid.Offset }"
  >
    <label :for="id" class="field__label">
      <slot></slot>
    </label>
    <textarea
      v-if="!disabled"
      ref="textarea"
      :value="value"
      :id="id"
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      :readonly="readonly"
      :rows="textrows"
      @input="update($event.target.value)"
      @keydown.enter="handleEnter"
    ></textarea>
    <pre v-else>{{ value }}</pre>
    <small v-if="error" style="color: red; font-style: italic">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'field-textarea',
  props: {
    error: String,
    grid: Object,
    id: String,
    name: String,
    placeholder: String,
    disabled: Boolean,
    readonly: Boolean,
    textrows: Number,
    value: String
  },
  methods: {
    update(newValue) {
      this.fitAreaToText()
      this.$emit('input', newValue)
    },
    handleEnter(event) {
      if (event.key === 'Enter' && !event.shiftKey && !event.ctrlKey && !event.altKey && !event.metaKey) {
        event.preventDefault() // Prevent default behavior of adding a new line
        this.$emit('nextInput') // Emit an event for Enter key press
      }
    },
    fitAreaToText() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea
        if (textarea) {
          textarea.style.height = 'auto' // Reset height
          textarea.style.height = `${textarea.scrollHeight + 10}px` // Set to scroll height
        }
      })
    }
  }
}
</script>
